import { Box, Tooltip } from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';
import { usePreferences } from '../../contexts/PreferencesContext';
import { getMovementAlerts } from '../../utils/movementAlerts';

/**
 * MI-282 Rev2 — one consolidated alert icon per movement.
 *
 * A movement can trip several review signals at once; we show a single warning
 * icon (one colour) and list every active alert in the hover tooltip, instead
 * of a row of differently-coloured icons. Renders nothing when there's no alert.
 */
export default function MovementAlertIcon({ movement, boxSize = '0.6rem' }) {
  const { t } = useTranslation('movements');
  const { alerts: prefs } = usePreferences();
  const alerts = getMovementAlerts(movement, { t, prefs });
  if (alerts.length === 0) return null;

  const label = alerts.length === 1
    ? alerts[0].label
    : (
      <Box>
        {alerts.map(a => <Box key={a.key}>• {a.label}</Box>)}
      </Box>
    );

  return (
    <Tooltip label={label} fontSize="xs" hasArrow>
      <WarningIcon boxSize={boxSize} color="redesign.accent.alert" flexShrink={0} />
    </Tooltip>
  );
}
